module.exports = "<div class=image-container ng-repeat=\"image in adminHotelEditImagesCtrl.hotel.images | orderBy : 'priority'\" ng-class=\"{'selected': image.isSelected}\"><img class=\"img-thumbnail images\" ng-src={{image.url}} fallback-src=" + require("../../../../../images/nophoto/hotels.jpg") + " /><div class=checkbox-container><span class=\"glyphicon glyphicon-ok\" ng-click=adminHotelEditImagesCtrl.toggle(image)></span></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-edit-images/admin-hotel-edit-images.html
// module id = 624
// module chunks = 0